import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpParams } from '@angular/common/http';
import { ConfigServerService, CustomHttp } from '../../../../core';
import { FunilVendaSearch } from '../funil-venda-search';

@Injectable({
    providedIn: 'root'
})
export class FunilVendaSearchHttpService {
    private readonly resource = 'crm/funilvenda';
    private readonly pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa os funils de vendas */
    search(tiposFunilVendaFases: number[] = null): Observable<FunilVendaSearch> {
        // Params
        let params = new HttpParams();
        // Tipos das fases
        tiposFunilVendaFases?.forEach(tipoFunilVendaFase => {
            params = params.append('tipoFunilVendaFase', tipoFunilVendaFase?.toString() ?? null);
        });

        return this.customHttp.get<FunilVendaSearch>(this.pathApi, {params});
    }
}
